import {NgModule} from '@angular/core';
import {TranslatePipe} from './translate.pipe';
import {TranslateDbPipe} from './translatedb.pipe';

@NgModule({
  declarations: [TranslatePipe, TranslateDbPipe],
  exports: [TranslatePipe, TranslateDbPipe]
})
export class TranslateModule {
}
